// extracted by mini-css-extract-plugin
export default {"check":"EditMatchTools_check__IWolG","xMark":"EditMatchTools_xMark__wLB2Z","switch":"EditMatchTools_switch__AhxVW","slider":"EditMatchTools_slider__Xj1Bw"};